import { render, staticRenderFns } from "./pageUserUICustom.vue?vue&type=template&id=35f52b02&scoped=true&"
import script from "./pageUserUICustom.vue?vue&type=script&lang=js&"
export * from "./pageUserUICustom.vue?vue&type=script&lang=js&"
import style0 from "./pageUserUICustom.vue?vue&type=style&index=0&id=35f52b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f52b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f52b02')) {
      api.createRecord('35f52b02', component.options)
    } else {
      api.reload('35f52b02', component.options)
    }
    module.hot.accept("./pageUserUICustom.vue?vue&type=template&id=35f52b02&scoped=true&", function () {
      api.rerender('35f52b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/pageUserUICustom.vue"
export default component.exports